var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-button",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: "Ticket pinnen",
          expression: "'Ticket pinnen'",
        },
      ],
      staticClass: "link",
      class: { checked: _vm.checked },
      attrs: { flat: "" },
      on: {
        click: function ($event) {
          return _vm.onClick()
        },
      },
    },
    [_c("w-fa", { attrs: { icon: "thumbtack" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }